import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { OrganizationDataModel } from '../../../models/organization/organization-data.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddressDataModel } from '../../../models/person/address-data.model';
import { Globals } from '../../../globals';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PatientDialogDataModel } from '../../patient/patient-dialog-data.model';
import { ContactDataModel } from '../../../models/person/contact-data.model';
import { ContactCommsDataModel } from '../../../models/person/contact-comms-data.model';
import { OrganizationsService } from './organizations-service';
import { StaticDataService } from '../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { OrganizationContactDataModel } from '../../../models/organization/organization-contact-data.model';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Constants } from '../../../constants';
import { TdoTableSelectionEvent } from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableV2Component } from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { OrganizationAddressDataModel } from '../../../models/organization/organization-address-data.model';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { ActivatedRoute } from '@angular/router';
import { ORGANIZATION_TYPE } from 'src/app/models/constants/organization-type.model';
import { throwError, forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Component({
    selector: 'app-organization-configuration',
    templateUrl: './organization-configuration.component.html',
    styleUrls: ['./organization-configuration.component.scss']
})
export class OrganizationConfigurationComponent implements OnInit {

    @Input() isDialogMode: boolean = false;
    @Input() isViewOnly: boolean = false;
    @Input() enumOrganizationTypeId: string = Constants.emptyGuid;
    @Input() organizationId: string = Constants.emptyGuid;
    @Input() showOrganizationTypeSelection: boolean = true;
    @Input() showOnlyInsurance: boolean = false;
    @Input() TDOCID: number = 0;
    @Output() NewOrganizationID: EventEmitter<string> = new EventEmitter<string>();


    @ViewChild('organizationTable', { static: false }) organizationTable: TdoTableV2Component;

    organizationTypeEnums: EnumValidValueItemModel[] = [];
    dataOrganizations: OrganizationDataModel[];
    selectedOrganization: OrganizationDataModel;
    addresses: AddressDataModel[];
    contacts: ContactDataModel[];
    addressRevert: AddressDataModel;
    organizationNameRevert: string = '';
    organizationDescriptionRevert: string = '';
    contactMode = PatientDialogDataModel.MODE_EDIT_CONTACT;
    contactEntityType = PatientDialogDataModel.TYPE_ORGANIZATION;
    selectedOrganizationContacts: OrganizationContactDataModel[] = [];
    selectedContact: ContactCommsDataModel;
    selectedContactID: string;
    organizationContact: OrganizationContactDataModel;
    //enumOrganizationTypeInsuranceCompany: string = '00000044-1000-0000-0000-000000000002';
    claimBillingBlockedFlag = false;

    isSaved: boolean = false;

    saveDisabled: boolean = true;
    isEditing: boolean = false;
    isLoading: boolean = false;
    isSaving: boolean = false; // Tracks if a save operation is in progress
    isLoadingOrganizations: boolean;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly snackBar: MatSnackBar,
        private readonly globals: Globals,
        private readonly organizationsService: OrganizationsService,
        private readonly staticDataService: StaticDataService,
        private readonly route: ActivatedRoute,
        private readonly dialog: MatDialog,
    ) { }

    ngOnInit(): void {

        this.route.queryParams.subscribe(params => {
            if (params.enumOrgType !== undefined)
                this.enumOrganizationTypeId = params.enumOrgType;
            else
                this.enumOrganizationTypeId = '00000000-0000-0000-0000-000000000000';

            this.initData();
        });
    }
    initData(): void {
        if (window.location.href.includes('insurance-companies')) {
            this.showOnlyInsurance = true;
            this.showOrganizationTypeSelection = false;
        }

        if (this.data?.showOnlyInsurance) {
            this.showOnlyInsurance = true;
            this.showOrganizationTypeSelection = false;
        }

        if (this.data?.isDialogMode) {
            this.isDialogMode = this.data.isDialogMode;
            if (this.isDialogMode) {
                this.isEditing = true;
                this.saveDisabled = false;
            }
        }

        if (this.data?.enumOrganizationTypeId) {
            this.enumOrganizationTypeId = this.data.enumOrganizationTypeId;
        }

        if (this.data?.TDOCID) {
            this.TDOCID = this.data.TDOCID;
        }


        if (this.data?.enumOrganizationTypeId) {

            this.enumOrganizationTypeId = this.data.enumOrganizationTypeId;
        }

        if (this.data?.isViewOnly) {
            if (this.data.isViewOnly) {
                this.isViewOnly = this.data.isViewOnly;
                this.saveDisabled = true;
                this.isEditing = false;
            }
        }

        // get organization type enums
        this.organizationsService.getEnumValidValueItemsByValidValueName('enumOrganizationType').subscribe((types) => {

            this.organizationTypeEnums = types;
        }, err => {
            this.createMessage('Error loading organization types', 'Error');
        });

        // load organizations
        if (this.isDialogMode) {
            this.loadOrganization(this.organizationId);
        }
        else {
            if (this.showOnlyInsurance) {
                this.enumOrganizationTypeId = ORGANIZATION_TYPE.InsuranceCompany;// this.enumOrganizationTypeInsuranceCompany;
            }
            this.loadOrganizations(true, this.enumOrganizationTypeId);
        }
    }

    onClaimBillingBlocked() {
        this.claimBillingBlockedFlag = true;
        this.createMessage('There is already a Claim Billing address. You can only assign one.', 'Warning');
    }

    loadOrganizations(setFirstSelected: boolean, enumOrganizationTypeId: string) {

        // get orgs
        this.isLoadingOrganizations = true;
        this.dataOrganizations = [];
        this.organizationsService.getAllOrganizations(enumOrganizationTypeId).subscribe((orgs) => {
            this.dataOrganizations = orgs;
            this.isLoadingOrganizations = false;
            if (setFirstSelected) {
                // select first organization
                if (this.dataOrganizations.length > 0) {
                    this.selectedOrganization = this.dataOrganizations[0];
                    this.setSelectedOrganization();
                    if (this.isDialogMode) {
                        const organizationDataContact = new OrganizationContactDataModel();
                        organizationDataContact.dataContact = new ContactDataModel();
                        organizationDataContact.ContactId = '';

                        if (!this.selectedOrganization.dataContacts) {
                            this.selectedOrganization.dataContacts = [];
                        }

                        this.selectedOrganization.dataContacts.push(organizationDataContact);
                        this.selectedOrganization.dataOrganizationContacts = [];
                        this.selectedOrganization.dataOrganizationContacts.push(organizationDataContact);

                        this.getContactsForOrganization();
                        this.getAddressesForOrganization();
                    }
                }
                else {
                    // no organizations exist, create empty organization
                    this.addOrganization();
                }
            }

            // load tdo table
            this.updateTdoTables();
        }, err => {
            this.isLoadingOrganizations = true;
            this.createMessage('Error loading organizations', 'Error');
        });
    }

    loadOrganization(organizationId: string) {
        // get org
        this.organizationsService.getOrganization(organizationId).subscribe((orgs) => {
            if (orgs !== null) {
                this.dataOrganizations = [orgs];

                if (this.dataOrganizations.length > 0) {
                    this.selectedOrganization = this.dataOrganizations[0];
                    this.setSelectedOrganization();
                    if (this.isDialogMode) {
                        const organizationDataContact = new OrganizationContactDataModel();
                        organizationDataContact.dataContact = new ContactDataModel();
                        organizationDataContact.ContactId = '';

                        if (!this.selectedOrganization.dataContacts) {
                            this.selectedOrganization.dataContacts = [];
                        }

                        this.selectedOrganization.dataContacts.push(organizationDataContact);
                        this.selectedOrganization.dataOrganizationContacts = [];
                        this.selectedOrganization.dataOrganizationContacts.push(organizationDataContact);

                        // this.getAddressesForOrganization();
                        // this.getContactsForOrganization();
                    }
                } else {
                    // no organizations exist, create empty organization
                    this.addOrganization();
                }

                // load tdo table
                const ivl = setInterval(() => {
                    if (!this.organizationTable) {
                        return;
                    }
                    clearInterval(ivl);
                    this.updateTdoTables();
                }, 100);
            }
            else {
                this.selectedOrganization = new OrganizationDataModel();
                this.selectedOrganization.TDOIC = this.TDOCID;
                this.selectedOrganization.enumOrganizationTypeId = this.enumOrganizationTypeId;
                this.dataOrganizations = [];
            }
        }, err => {
            this.createMessage('Error loading organizations', 'Error');
        });

    }

    getEnumValidValueItemsByValidValueName(ValidValueName: string) {
        return this.organizationsService.getEnumValidValueItemsByValidValueName(ValidValueName).toPromise();
    }

    setSelectedOrganization() {
        // address
        
        this.selectedOrganization.isNew = false;
        if (!this.selectedOrganization.dataOrganizationAddresses) {
            this.selectedOrganization.dataOrganizationAddresses = [];
            this.selectedOrganization.dataAddress = new AddressDataModel();
            const newAddress = new AddressDataModel();
            newAddress.LOCID = this.globals.LOCID;
            newAddress.Address1 = '';
            newAddress.Address2 = '';
            newAddress.Address3 = '';
            newAddress.PostCode = '';
            newAddress.State = '';
            newAddress.City = '';
            newAddress.enumAddressCategoryID = '';
            newAddress.Suburb = '';

            const newOrganizationAddress = new OrganizationAddressDataModel();
            newOrganizationAddress.dataAddress = newAddress;
            this.selectedOrganization.dataOrganizationAddresses = [newOrganizationAddress];
            this.addresses = [newAddress];
        } else {
            this.addresses = this.selectedOrganization.dataOrganizationAddresses.map(p => p.dataAddress);
        }

        // dataContacts
        this.getContactsForOrganization();
        if (!this.selectedOrganization.dataOrganizationContacts) {
            this.selectedOrganization.dataOrganizationContacts = [];
            const newConTact = new ContactDataModel();
            newConTact.ContactId = '';
            newConTact.FirstName = '';
            newConTact.MidName = '';
            newConTact.LastName = '';

            const newOrganizationContact = new OrganizationContactDataModel();
            newOrganizationContact.dataContact = newConTact;
            this.selectedOrganization.dataOrganizationContacts = [newOrganizationContact];
        }
    }



    onSave() {
        if (this.isSaving) {
            console.warn('Save operation already in progress. Please wait.');
            return;
        }

        // Validate data
        if (!this.validateData()) {
            console.error('Validation failed. Save operation aborted.');
            return;
        }

        this.isSaving = true; // Block UI interactions
        this.isLoading = true; // Show loading indicator

        const orgs: OrganizationDataModel[] = [this.selectedOrganization];

        console.log('Saving organization data:', orgs);

        // Save organization
        this.organizationsService.saveOrganizations(orgs).pipe(
            switchMap(savedOrganizations => {
                if (savedOrganizations.length > 0) {
                    this.selectedOrganization = savedOrganizations[0];
                    console.log('Organization saved. Now saving addresses and contacts.');

                    // Save addresses and contacts
                    return forkJoin([
                        this.organizationsService.saveOrganizationAddresses(this.addresses, this.selectedOrganization.OrganizationID),
                        this.organizationsService.saveOrganizationContacts(this.contacts, this.selectedOrganization.OrganizationID),
                    ]);
                } else {
                    throw new Error('Failed to save the organization.');
                }
            })
        ).subscribe({
            next: ([savedAddresses, savedContacts]) => {
                console.log('Addresses saved:', savedAddresses);
                console.log('Contacts saved:', savedContacts);

                // Update UI with saved data
                this.addresses = savedAddresses.map(addr => addr.dataAddress);
                this.contacts = savedContacts.map(contact => contact.dataContact);

                // Show success message
                this.createMessage('Organization saved successfully!', 'Success');

                // Update saving state
                this.isSaving = false;
                this.isLoading = false;

                // Refresh the organization list
                this.loadOrganizations(false, this.enumOrganizationTypeId);

                this.saveDisabled = true;

                this.isEditing = false;



            },
            error: err => {
                console.error('Error during save operation:', err);

                // Show error message and unblock UI
                this.isSaving = false;
                this.isLoading = false;
                this.createMessage('Error saving organization. Please try again.', 'Error');
            }
        });
    }

    private validateData(): boolean {
        console.log('Validating organization data:', this.selectedOrganization);

        if (!this.selectedOrganization.OrganizationName) {
            this.createMessage('Organization name is required.', 'Error');
            return false;
        }

        if (!this.addresses || this.addresses.length === 0) {
            this.createMessage('At least one address is required.', 'Error');
            return false;
        }

        // Block saving if user tried to assign Claim Billing and it was rejected
        if (this.claimBillingBlockedFlag) {
            this.createMessage('Claim Billing is already assigned. Please fix it before saving.', 'Error');
            this.claimBillingBlockedFlag = false;
            return false;
        }

        const emptyCategories = this.addresses.filter(a => !a.enumAddressCategoryID);
        if (emptyCategories.length > 0) {
            this.createMessage('All addresses must have a location type selected.', 'Error');
            return false;
        }

        const isInsuranceCompany = this.enumOrganizationTypeId === ORGANIZATION_TYPE.InsuranceCompany;
        if (isInsuranceCompany) {
            const claimBillingCategoryId = '00000008-1000-0000-0000-000000000005';
            const claimBillingCount = this.addresses.filter(a => a.enumAddressCategoryID === claimBillingCategoryId).length;
            if (claimBillingCount > 1) {
                this.createMessage('Only one Claim Billing address is allowed.', 'Error');
                return false;
            }
        }


        if (!this.contacts || this.contacts.length === 0) {
            console.warn('No contacts provided.');
        }

        return true;
    }



    onCancel(event) {
        this.saveDisabled = true;
        this.isEditing = false;

        this.selectedOrganization.dataAddress = this.addressRevert;
        if (this.addresses.length > 0) { this.addresses[0] = this.addressRevert; }
        this.dataOrganizations.find(a => a.OrganizationID === this.selectedOrganization.OrganizationID).dataAddress = this.addressRevert;

        this.selectedOrganization.OrganizationName = this.organizationNameRevert;
        this.selectedOrganization.Description = this.organizationDescriptionRevert;
        this.dataOrganizations.find(a => a.OrganizationID === this.selectedOrganization.OrganizationID).OrganizationName = this.organizationNameRevert;
        this.dataOrganizations.find(a => a.OrganizationID === this.selectedOrganization.OrganizationID).Description = this.organizationDescriptionRevert;
    }


    onEdit(event) {
        this.saveDisabled = false;
        this.isEditing = true;
    }

    getContactsForOrganization() {
        // contacts for organization
        if (this.selectedOrganization.OrganizationID === undefined) {
            return;
        }


        this.organizationsService.getAllOrganizationContacts(this.selectedOrganization.OrganizationID).subscribe((contacts) => {
            if (contacts.length > 0) {
                this.selectedOrganization.dataOrganizationContacts = [];
                contacts.forEach(a => {
                    this.selectedOrganization.dataOrganizationContacts.push(a);
                    this.contacts = this.selectedOrganization.dataOrganizationContacts.map(p => p.dataContact);
                    this.contacts.forEach(c => {
                        c.mainPhoneCommunication = c.dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Phone);
                        c.mainEmailCommunication = c.dataContactComms.find(y => y.enumCommMethodID === CommMethodEnum.Email);
                    });
                });
            } 
            else {
                this.contacts = [];
            }
        }, err => {
            this.createMessage('Error loading organization contacts', 'Error');
        });

    }

    getAddressesForOrganization() {
        this.organizationsService.getAllAddresses(this.selectedOrganization.OrganizationID).subscribe((res) => {
            this.organizationContact = res[0];
            this.addresses = res[0].dataContact.dataAddresses;
        });
    }

    updateTdoTables() {
        // update table
        if (this.organizationTable)
            this.organizationTable.updateData(this.dataOrganizations);
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    addOrganization() {
        const newOrg = new OrganizationDataModel();

        // enum type
        if (this.enumOrganizationTypeId !== Constants.emptyGuid) {
            newOrg.enumOrganizationTypeId = this.enumOrganizationTypeId;
        }

        this.setAllOrgsToIsNewFalse();
        newOrg.isNew = true;
        newOrg.TDOIC = !isNaN(Number(this.globals.TDOCID)) ? Number(this.globals.TDOCID) : 0;
        this.selectedOrganization = newOrg;
        this.dataOrganizations.push(newOrg);

        const organizationDataContact = new OrganizationContactDataModel();
        const organizationDataContactContact = new ContactDataModel();
        const organizationDataContactAddress = new AddressDataModel();
        const organizationDataContactComm = new ContactCommsDataModel();

        organizationDataContact.dataContact = organizationDataContactContact;
        organizationDataContact.dataContact.dataAddresses = [];
        organizationDataContact.dataContact.dataAddresses.push(organizationDataContactAddress);
        organizationDataContact.dataContact.dataContactComms = [];
        organizationDataContact.dataContact.dataContactComms.push(organizationDataContactComm);
        this.selectedOrganization.dataOrganizationContacts = [];
        this.selectedOrganization.dataOrganizationContacts.push(organizationDataContact);

        this.contacts = [];
        this.addresses = [];


        this.updateTdoTables();
        this.isSaved = true;

        if (!this.isDialogMode) {
            this.createMessage('Organization added', 'Success');
        }

        // simulate edit
        this.saveDisabled = false;
        if (!this.isViewOnly) {
            this.isEditing = true;
        }
    }

    setAllOrgsToIsNewFalse() {
        this.dataOrganizations.forEach(a => {
            a.isNew = false;
        });
    }

    onNew(event) {
        this.addOrganization();
    }

    onTabChangeAddressContacts($event: MatTabChangeEvent) {

    }

    contactErrorMessage($event: any) {

    }

    onRowSelected(event: TdoTableSelectionEvent) {
        if (this.selectedOrganization) {
            this.selectedOrganization.dataAddress = this.addresses[0];
        }

        this.selectedOrganization = event.row.model as OrganizationDataModel;
        this.setSelectedOrganization();
        this.isEditing = false;
        this.saveDisabled = true;
        // contacts for organization
        // this.getContactsForOrganization();
    }
}
